import { render, staticRenderFns } from "./UiAlertModal.vue?vue&type=template&id=7cf48f59&"
import script from "./UiAlertModal.vue?vue&type=script&lang=js&"
export * from "./UiAlertModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports